import React, { useState } from 'react';
import { Collapse as AntCollapse, Tooltip } from 'antd';
import type { CollapseProps as AntCollapseProps } from 'antd';
import { ReactComponent as DownOutlinedIcon } from 'assets/icons/ArrowDownIcon.svg';
import { ReactComponent as WarningIcon } from 'assets/icons/Warning.svg';

interface CustomCollapseProps extends AntCollapseProps {
  title: string;
  subtitle?: string;
  description?: string;
  warning?: string;
}

const Collapse: React.FC<CustomCollapseProps> = ({
  title,
  subtitle,
  children,
  warning,
  ...props
}) => {
  const [activeKey, setActiveKey] = useState<string | string[]>([]);

  return (
    <div
      className={
        'pt-4 pb-2 border-b border-b-BeigeHellio-5 last:border-b-0 last:pb-0'
      }
    >
      <AntCollapse
        activeKey={activeKey}
        onChange={setActiveKey}
        bordered={false}
        className="bg-white"
        {...props}
      >
        <AntCollapse.Panel
          key="1"
          showArrow={false}
          header={
            <div className={'flex flex-nowrap items-center w-full'}>
              <p className="gap-1 leading-none flex-1">
                <span className="text-GrisHellio-6 text-base font-semibold ">
                  {title}
                </span>
                {subtitle && (
                  <span className="text-GrisHellio-6 text-xs font-normal ">
                    {' '}
                    {subtitle}
                  </span>
                )}
                {!!warning && (
                  <>
                    {' '}
                    <Tooltip title={warning} arrow>
                      <WarningIcon className={'inline'} />
                    </Tooltip>
                  </>
                )}
              </p>
              <DownOutlinedIcon className={'collapse-icon'} />
            </div>
          }
        >
          {props.description && (
            <p className="text-GrisHellio-5 text-xs font-normal leading-normal mb-4">
              {props.description}
            </p>
          )}
          <div className={'pb-2'}>{children}</div>
        </AntCollapse.Panel>
      </AntCollapse>
    </div>
  );
};

export default Collapse;
